//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function() {
    // .header-btnがクリックされたときの処理
    $(".header-btn").click(function () {
        // .header-btnと.header-spのopenクラスをトグル（追加/削除）
        $(".header-btn, .header-sp").toggleClass("open");
    });

    // .header-sp内のaタグがクリックされたときの処理
    $(".header-sp a").click(function () {
        // .header-btnと.header-spからopenクラスを削除
        $(".header-btn, .header-sp").removeClass("open");
    });

    //faqのページのjs
    $('.faq-content-box').click(function() {
        $(this).find('.faq-content-box--q').stop(true, true).slideToggle();
        $(this).toggleClass('open');
    });

    //スクロールしたら背景色を変更する
    let headerChanged = false; // 一度変更されたかどうかのフラグ
    $(window).on('scroll', function () {
        const triggerHeight = Math.min(window.innerHeight, 1000);

        // 背景色がまだ黒くなっていない場合のみ変更
        if (!headerChanged && $(window).scrollTop() > triggerHeight) {
            $('.header').css('background-color', 'black');
            headerChanged = true; // フラグを立てる
        }
    });

    //dealer一覧ページの展開
    $(".dealer-shop--title").on("click", function () {
        const $this = $(this);
        const $inner = $this.next(".dealer-shop--none");

        // アニメーションの競合を防ぐためstop()を使用
        $inner.stop(true, true).slideToggle(300);

        // .openクラスの付け外し
        $this.toggleClass("open");
    });

    //領域に入ったら下からfadeさせる
    $(window).on('scroll', function () {
        $('.fade').each(function () {
            const elementTop = $(this).offset().top;
            const viewportBottom = $(window).scrollTop() + $(window).height();

            if (viewportBottom > elementTop + 500) {  // 少し手前で発火
                $(this).addClass('is-visible');
            }
        });
    });

    // 初期ロード時にもチェック
    $(window).trigger('scroll');

    //特定の領域に入ったら画像を縮小
    $(window).on('scroll', function() {
        $('.bg_fade').each(function() {
            const elemTop = $(this).offset().top;
            const elemBottom = elemTop + $(this).outerHeight();
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();

            // 画面内に入ったかつ、まだ縮小されていない場合
            if (scrollTop + windowHeight > elemTop && scrollTop < elemBottom && !$(this).hasClass('shrunk')) {
                $(this).addClass('shrunk'); // 縮小状態にするクラスを追加
            }
        });
    });

    //スマホのアコーディオン処理
    $('.header-sp-nav--wrap span').on('click', function () {
        const $thisWrap = $(this).closest('.header-sp-nav--wrap');
        const $thisInner = $thisWrap.find('.header-sp-nav--inner');

        // アニメーションが途中で止まらないようにstop()を追加
        $('.header-sp-nav--inner').not($thisInner).stop(true, true).slideUp();
        $thisInner.stop(true, true).slideToggle();

        // クリックしたspanにactiveクラスを追加し、他からは削除
        $('.header-sp-nav--wrap span').not(this).removeClass('active');
        $(this).toggleClass('active');
    });
});

//フロントページの最後のブロック、カウントアップする
document.addEventListener("DOMContentLoaded", function () {
    const target = document.querySelector('.front-history');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counters = document.querySelectorAll('.front-history-box--nm span');
                counters.forEach(counter => {
                    countUp(counter);
                });
                observer.disconnect(); // 1度カウントアップしたらオブザーバーを停止
            }
        });
    });

    observer.observe(target);

    function countUp(counter) {
        const targetValue = parseInt(counter.innerText.replace(',', ''));
        const duration = 3000; // 3秒
        let start = 0;
        const increment = targetValue / (duration / 16); // 60fpsのため16msごとに更新

        function updateCounter() {
            start += increment;
            if (start < targetValue) {
                counter.innerText = Math.ceil(start).toLocaleString();
                requestAnimationFrame(updateCounter);
            } else {
                counter.innerText = targetValue.toLocaleString();
                // カウント終了後に <em></em> を追加
                counter.innerHTML += "<em></em>";
            }
        }

        updateCounter();
    }
});

//フロントのスライド
document.addEventListener('DOMContentLoaded', function () {

    const modelSwiper = new Swiper('.modelSwiper', {
        loop: false,
        effect: 'fade',
        slidesPerView: 1,
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    //詳細ページのスクロール
    const modelScroll = new Swiper(".modelScroll", {
        slidesPerView: 1.3,
        spaceBetween: 15,
        freeMode: true,
        scrollbar: {
            el: ".swiper-scrollbar",
        },
        mousewheel: true,
        breakpoints: {
            // スライドの表示枚数：500px以上の場合
            768: {
                slidesPerView: 2.8,
                spaceBetween: 35,
            }
        }
    });
});

//フロントのスライド
// 各frontSwiperに対してSwiperを初期化
document.querySelectorAll('.frontSwiper').forEach((swiperElement) => {
    const swiperContainer = swiperElement.closest('.front-slide-box');
    const mainTitleElement = swiperContainer.querySelector('.front-slide--maintitle');

    // 最初のスライドのタイトルを取得して設定
    const firstSlide = swiperElement.querySelector('.swiper-slide');
    mainTitleElement.textContent = firstSlide.querySelector('.front-slide-box--title').textContent;

    // Swiperの初期化
    const swiper = new Swiper(swiperElement, {
        loop: false,
        slidesPerView: 1,
        speed: 1000,
        navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: swiperContainer.querySelector('.swiper-pagination'),
            clickable: true,
            type: "fraction",
        },
        on: {
            slideChange: function () {
                const activeSlide = swiper.slides[swiper.activeIndex];
                mainTitleElement.textContent = activeSlide.querySelector('.front-slide-box--title').textContent;
            }
        }
    });
});

const swiper = new Swiper(".mainSwiper", {
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

//タブで表示の切り替え
$(document).ready(function () {
    $('.front-slide-nav--link').on('click', function () {
        // すべての front-slide-nav--link から active クラスを削除
        $('.front-slide-nav--link').removeClass('active');

        // クリックされた要素に active クラスを追加
        $(this).addClass('active');

        // data-event 属性の値を取得
        var selectedEvent = $(this).data('event');

        // すべての front-slide-box から active クラスを削除
        $('.front-slide-box').removeClass('active');

        // IDが data-event の値と一致する front-slide-box に active クラスを追加
        $('#' + selectedEvent).addClass('active');
    });
});

//モデル詳細色の名前を取得
// 初期表示: 最初のem内のspanのテキストを表示
const title = document.querySelector('.model-color--title');
const emElements = document.querySelectorAll('.model-color em');

// 初期設定：最初のemにactiveクラスをつけ、タイトルを設定
const setActiveEm = (em) => {
    emElements.forEach(e => e.classList.remove('active')); // 全てのemからactiveを外す
    em.classList.add('active'); // クリックされたemにactiveをつける
    title.textContent = em.querySelector('span').textContent; // タイトルを更新
};

// 初期表示設定（最初のem）
setActiveEm(emElements[0]);

// 各emにクリックイベントを追加
emElements.forEach(em => {
    em.addEventListener('click', () => setActiveEm(em));
});


